import { useMemo } from 'react';

import { useSuspenseQuery } from '@/hooks/use-suspense-query';
import { MeasurementSystem, UnitType } from '@/types';
import { supabaseClient } from '@/utils/supabase-client';

// TODO: move this out of hooks

export function useUnits(types: UnitType[], system: MeasurementSystem) {
  const { data, isLoading, count } = useSuspenseQuery(
    supabaseClient.from('unit').select('*').contains('unit_system', [system]),
  );

  const units = useMemo(
    () =>
      data?.filter((unit) => types.find((type) => type === unit.unit_type)) ??
      [],
    [data],
  );

  return {
    units,
    isLoading,
    count,
  };
}
